import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { Typography } from 'common/typography';
import { AdCampaignBudgetType } from 'modules/campaigns/types';

import { AdsCampaignWeeklyBudgetDetails } from './AdsCampaignWeeklyBudgetDetails';
import { BudgetOptionSelector } from './BudgetOptionSelector';
import { HelperText } from '../../HelperText';
import { BudgetOption } from '../types';

export type AdsCampaignWeeklyBudgetDetailsProps = {
  budgetOptions: BudgetOption[];
  isDisabled: boolean;
  campaignId?: string;
  budgetAmount: number;
  budgetType: AdCampaignBudgetType;
  bidAmount?: number;
  onChange?: (budgetType: AdCampaignBudgetType) => void;
};

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: ${MOBILE_BREAKPOINT}px) {
    padding-inline-end: 32px;
  }
`;

export const AdsCampaignWeeklyBudgetSelector = ({
  budgetOptions,
  isDisabled,
  campaignId,
  budgetAmount,
  budgetType,
  bidAmount,
  onChange,
}: AdsCampaignWeeklyBudgetDetailsProps) => {
  const { formatMessage } = useIntl();

  return (
    <ContentWrapper data-testid="ad-campaign-budget-selector-section">
      {campaignId || budgetType === 'custom' || bidAmount !== undefined ? (
        <>
          {!campaignId ? (
            <Typography.Body3>
              <FormattedMessage id="campaigns.ads.budget.budget-options-description" />
            </Typography.Body3>
          ) : null}
          <AdsCampaignWeeklyBudgetDetails budgetAmount={budgetAmount} bidAmount={bidAmount} />
        </>
      ) : (
        <BudgetOptionSelector
          name="budgetType"
          budgetOptions={budgetOptions}
          isDisabled={isDisabled}
          defaultValue={budgetType}
          onChange={onChange}
        />
      )}
      <HelperText text={formatMessage({ id: 'campaigns.ads.budget.vat-text' })} />
    </ContentWrapper>
  );
};
